import React from 'react'
import _ from 'lodash'
import { ContentColumn, DividerHeader, CodeColumn } from '../../styles/utils'
import * as styles from './styles'
import { refNameToSlug } from '../../util'

export default ({ content, refName }) => {
  const { backPaths, backReferences, operations } = content
  const refs = backReferences[refName] || []
  if (_.isEmpty(refs)) return null

  const res = (
    _.flatMap(refs, (backRef) => {
      const pathName = backPaths[Object.keys(backPaths).filter(k => k === backRef)]
      const operation = pathName && operations.filter(o => o.path === pathName[0])
      const paths = operation || [{ id: refNameToSlug(backRef), title: backRef }]
      return _.map(paths, p => (
        <styles.OneOfBlock key={p.title}>
          <styles.Text>
            <a href={_.join(['#', p.id], '')}>
              {p.title}
            </a>
          </styles.Text>
        </styles.OneOfBlock>
      ))
    }))

  return (
    <React.Fragment>
      <ContentColumn>
        <DividerHeader>Referenced in</DividerHeader>
        {_.uniqBy(_.sortBy(res, 'key'), 'key')}
      </ContentColumn>
      <CodeColumn />
    </React.Fragment>
  )
}
